__turbopack_context__.v({
  "container": "pxkSWa_container",
  "count": "pxkSWa_count",
  "emptyMessage": "pxkSWa_emptyMessage",
  "tag": "pxkSWa_tag",
  "tags": "pxkSWa_tags",
});
